module.exports = __webpack_public_path__ + "static/media/python-logo.bbae860b.svg";